import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/system';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import ErrorIcon from '@mui/icons-material/Error';

import { CHILDREN_PROP_TYPES } from 'propTypes';
import { TOMATO } from 'styles/theme/colors';

const msgColor = TOMATO;

const StyledBox = styled(Box)(({ theme, useErrorStyle }) => ({
  display: 'flex',
  padding: '10px',
  border: `${useErrorStyle ? '2px' : '1px'} solid ${
    useErrorStyle ? theme.palette.error.main : msgColor
  }`,
  borderRadius: `${useErrorStyle ? 4 : 0}px`,
  color: useErrorStyle ? theme.palette.error.main : msgColor,
  fontSize: '14px'
}));

const StyledErrorIcon = styled(ErrorIcon)(({ theme, useErrorStyle }) => ({
  fill: useErrorStyle ? theme.palette.error.main : msgColor,
  fontSize: '16px'
}));

const StyledTypography = styled(Typography)(({ theme, useErrorStyle }) => ({
  color: useErrorStyle ? theme.palette.error.main : msgColor,
  fontSize: '14px',
  lineHeight: 1.2
}));

function OutlinedBoxError({ children, useErrorStyle = true }) {
  return (
    <StyledBox useErrorStyle={useErrorStyle}>
      <Box width="20px" mr={1}>
        <StyledErrorIcon useErrorStyle={useErrorStyle} />
      </Box>
      <Box flex="2">
        <StyledTypography useErrorStyle={useErrorStyle}>
          {children}
        </StyledTypography>
      </Box>
    </StyledBox>
  );
}

OutlinedBoxError.propTypes = {
  children: CHILDREN_PROP_TYPES.isRequired,
  useErrorStyle: PropTypes.bool
};

export default OutlinedBoxError;
